import { State } from "../types/store";

export const selectCollaborators = (state: State) => state.collaborators.list;
export const selectOwner = (state: State) => state.collaborators.owner;
